import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CalendarModule } from 'primeng/calendar';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { ExternalEoiGenerateModalComponent } from './external-eoi-generate-modal.component';

/**
 * Import this wherever an "Generate External EOI Link" action is offered
 * (project External EOI tab, EOI detail, lead detail).
 */
@NgModule({
  imports: [CommonModule, FormsModule, NgSelectModule, CalendarModule, ReMultiselectModule],
  declarations: [ExternalEoiGenerateModalComponent],
  exports: [ExternalEoiGenerateModalComponent],
})
export class ExternalEoiGenerateModalModule {}
